import React, { useState } from "react";
import styled from "styled-components";

import { Button } from "../../theme";
import Modal from "../modal/Modal";

const Container = styled.div`
  padding: 20px;

  p {
    margin-bottom: 1.4rem;
  }

  div {
    margin-top: 20px;
    text-align: center;
  }
`;

function PasswordRequestModal() {
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = () => setIsOpen(false);

  return (
    <Modal
      isOpen={isOpen}
      title="Demande de mot de passe envoyée"
      contentLabel="Demande de mot de passe envoyée"
      handleClose={handleClose}
      hideButton
    >
      <Container>
        <p>Votre demande a bien été envoyée.</p>
        <p>
          Vous recevrez très rapidement par email un lien pour créer votre
          nouveau mot de passe.
        </p>
        <div>
          <Button onClick={handleClose}>J'ai bien compris</Button>
        </div>
      </Container>
    </Modal>
  );
}

export default PasswordRequestModal;
